import React, { createContext, useContext, useState } from "react";

interface PermissionsContextType {
  formattedPermissions: FormattedPermissions | null;
  setFormattedPermissions: (permissions: FormattedPermissions | null) => void;
}

const PermissionsContext = createContext<PermissionsContextType | undefined>(
  undefined
);

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [formattedPermissions, setFormattedPermissions] =
    useState<FormattedPermissions | null>(null);

  return (
    <PermissionsContext.Provider
      value={{ formattedPermissions, setFormattedPermissions }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
};


export interface FormattedPermissions {
  roleId: string;
  pagePermissions: Array<{
    pageId: string;
    permissions: number[];
  }>;
}